// src/components/FinalCta.js
import React from 'react';

const FinalCta = () => {
  const scrollToForm = () => {
    const el = document.getElementById('lead-form');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="section final-cta" aria-labelledby="final-cta-heading">
      <div className="section-inner final-cta-inner glass-card">
        <h2 id="final-cta-heading">
          Ready to turn your marketing into a predictable lead engine?
        </h2>
        <p>
          Book your free consultation now. Limited consultation slots available each week.
        </p>
        {/* NEW: Urgency line */}
        <div className="cta-urgency">
          Limited consultation slots available each week.
        </div>
        <button
          className="btn-primary glow-pulse"
          onClick={scrollToForm}
        >
          Book Website Consultation (For Businesses Only)
        </button>
      </div>
    </section>
  );
};

export default FinalCta;
